module.exports = __webpack_public_path__ + "static/media/visa.868e1896.svg";